// @flow
import { useMutation, MutationOptions } from 'react-query';
import { deleteAffordaPortalForm } from 'services/affordaPortalForms';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';
import useUserProfileQuery from 'hooks/queries/useUserProfileQuery';
import useMemoizedQueryOptions from './useMemoizedQueryOptions';

type Props = {
  options?: MutationOptions,
};

const useDeleteAffordaPortalFormMutation = ({ options }: Props = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const { data: userProfile } = useUserProfileQuery();

  const memoizedOptions = useMemoizedQueryOptions({
    options,
    organizationId,
    propertyId,
    portalUserId: userProfile.portalUserId,
  });

  return useMutation(async (id: string) => {
    if (!organizationId || !propertyId) {
      throw new Error('organizationId and propertyId are required.');
    }
    if (!id && !userProfile?.portalUserId) {
      throw new Error(
        'Either id or portalUserId must be provided for deletion.',
      );
    }

    return deleteAffordaPortalForm({
      organizationId,
      propertyId,
      id,
      portalUserId: userProfile?.portalUserId,
    });
  }, memoizedOptions);
};

export default useDeleteAffordaPortalFormMutation;
